// Entry point. Wire DOM roots, construct Game, boot into BootScene, start loop.

import { Game } from "./game/Game";
import { BootScene } from "./scenes/BootScene";
import { mountFooter } from "./ui/Footer";
import { mountAnchor } from "./ui/AdManager";
import { autoDismissConsentBubble } from "./ui/HideConsentBubble";

function syncViewportTop(): void {
  const vv = window.visualViewport;
  const offset = vv ? Math.round(vv.offsetTop) : 0;
  document.documentElement.style.setProperty("--vp-top", `${offset}px`);
}

function start(): void {
  syncViewportTop();
  window.visualViewport?.addEventListener("resize", syncViewportTop);
  window.visualViewport?.addEventListener("scroll", syncViewportTop);

  mountFooter();
  mountAnchor();
  autoDismissConsentBubble();

  const canvas = document.getElementById("game-canvas") as HTMLCanvasElement | null;
  const sceneRoot = document.getElementById("scene-root");
  const hudRoot = document.getElementById("hud-root");
  if (!canvas || !sceneRoot || !hudRoot) {
    throw new Error("Required DOM roots missing");
  }

  const game = new Game(canvas, sceneRoot, hudRoot);
  game.sceneManager.transition(new BootScene(game));
  game.run();
}

start();
